module.exports = __webpack_public_path__ + "img/ministero-logo.26eb0db7.png";